import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

firebase.initializeApp({
  apiKey: "AIzaSyByGu14O18ZeSiE74LDupmTNIfi_ZqJcMM",
  authDomain: "actionslibrarytest.firebaseapp.com",
  databaseURL: "https://actionslibrarytest.firebaseio.com",
  projectId: "actionslibrarytest",
  storageBucket: "actionslibrarytest.appspot.com",
  messagingSenderId: "387136740425",
  appId: "1:387136740425:web:224d5e886ec6a255913398",
});

export default firebase;
